<template>
  <modal-vue-d
    name="partner-modal"
    width="804"
  >
    <div class="partner-link-modal__tabs">
      <div class="switcher _d _partner-link">
        <div v-for="(item, index) in renderTabs" :key="index" class="switcher__item">
          <button
            class="switcher__link"
            :class="{ '_active' : currentType === item.type }"
            @click="selectType(item.type)"
          >
            <svg
              class="switcher__icon"
              role="img"
              width="24"
              height="24"
              :fill="item.color"
            >
              <use :xlink:href="`#${item.icon}`" />
            </svg>
          </button>
        </div>
      </div>
      <div class="partner-link-modal__tabs-content _active">
        <div class="partner-link-content">
          <template v-for="item in renderForm">
            <div :key="`title_${item.id}`" class="partner-link-content__title">
              {{ item.title }}
            </div>
            <form :key="`form_${item.id}`" class="partner-link-form _new">
              <div class="partner-link-form__input">
                <textarea-control v-model="item.model" rows="3" disabled />
              </div>
              <partner-link-copy-btn :copy-value="item.model" />
            </form>
          </template>
        </div>
      </div>
    </div>
  </modal-vue-d>
</template>

<script>

import ModalVueD from '@/js/vue/ModalVueD';
import { TextareaControl } from '@book24/ui-components';
import getPartnersLink from '@/js/services/api/_candidate-to-api-clients/getPartnersLink';
import PartnerLinkCopyBtn from '@/js/vue/PartnerLink/PartnerLinkCopyBtn';

export default {
  name: 'PartnerLinkModal',
  components: {
    PartnerLinkCopyBtn,
    TextareaControl,
    ModalVueD,
  },
  data() {
    return {
      renderTabs: [
        {
          type: 'site',
          icon: 'Link_24',
          color: '#3d70b2',
        },
        {
          type: 'vk',
          icon: 'VK_24',
          color: '#51749c',
        },
        {
          type: 'youtube',
          icon: 'Youtube_24',
          color: '',
        },
        {
          type: 'tg',
          icon: 'Telegram_24',
          color: '',
        },
        {
          type: 'ok',
          icon: 'Odnoklassniki_24',
          color: '#FA890F',
        },
      ],
      partnerData: {
        graphicalLink: '',
        link: '',
        linkCode: '',
        shortLink: '',
      },
      currentType: 'site',
    };
  },
  computed: {
    renderForm() {
      return [
        {
          title: 'Ссылка для вставки',
          model: this.partnerData.link,
          id: 'link',
        },
        {
          title: 'Короткая ссылка',
          model: this.partnerData.shortLink,
          id: 'shortLink',
        },
        {
          title: 'Код для вставки',
          model: this.partnerData.linkCode,
          id: 'linkCode',
        },
        {
          title: 'Графическая ссылка',
          model: this.partnerData.graphicalLink,
          id: 'graphicalLink',
        },
      ];
    },
    getImage() {
      const ogImageTag = document.head.querySelector('[property="og:image"]');
      const ogImage = ogImageTag ? ogImageTag.content : '';
      if (ogImage.length > 0) {
        return ogImage;
      }
      return 'https://ndf.book24.ru/legacy/images/logo.png';
    },
    getTitle() {
      const h1Title = document.getElementsByTagName('h1')[0];
      const ogTitleTag = document.head.querySelector('[property="og:title"]');
      const ogTitle = ogTitleTag ? ogTitleTag.content : '';
      if (h1Title && h1Title.innerHTML.length > 0) {
        return h1Title.innerHTML;
      } if (ogTitle.length > 0) {
        return ogTitle;
      }
      return document.title;
    },
    getUrl() {
      const ogUrlTag = document.head.querySelector('[property="og:url"]');
      const ogUrl = ogUrlTag ? ogUrlTag.content : '';
      if (ogUrl.length > 0) {
        return ogUrl;
      }
      return `${window.location.protocol}//${window.location.host}${window.location.pathname}${window.location.search}`;
    },
  },
  mounted() {
    this.loadLinks();
  },
  methods: {
    selectType(type) {
      this.currentType = type;
      this.loadLinks();
    },
    loadLinks() {
      getPartnersLink({
        url: this.getUrl,
        image: this.getImage,
        title: this.getTitle,
        source: this.currentType,
      }).then((res) => {
        if (res.STATUS === 'OK') {
          this.partnerData.graphicalLink = res.DATA.graphical_link;
          this.partnerData.link = res.DATA.link;
          this.partnerData.linkCode = res.DATA.link_code;
          this.partnerData.shortLink = res.DATA.short_link;
        }
      });
    },
  },
};
</script>
